import { useLocalSearchParams } from 'expo-router'

import { IntentionSingleScreen } from '@/src/features/intention/ui/screens/IntentionSingleScreen'
import { parseIdDash } from '@/src/general/utils/parseIdDash'

const IntentionRouterPage = () => {
  const { idSharetoken } = useLocalSearchParams<{ idSharetoken: TIdDashSlug }>()
  if (!idSharetoken) return null

  const [intentionId, shareToken] = parseIdDash(idSharetoken)

  return <IntentionSingleScreen intentionId={intentionId} shareToken={shareToken} />
}

export default IntentionRouterPage
